import './App.css';
import React, { useEffect, useState } from 'react';
import useOneSignal from '../src/components/onesignal/useOneSignal';
import { RouterProvider } from "react-router-dom";
import { router } from '../src/router/index';
import Cookie from 'js-cookie';
import { initGA, trackPageView} from './utils/analytics';

// IMPORT THE PROVIDER
import { LogoProvider } from "./context/LogoContext";

function App() {

  const [theme, setTheme] = useState(() => {
    return Cookie.get("theme") || "dark-theme";
  });

  useEffect(() => {
  initGA(); 
  trackPageView(window.location.pathname);      // first page

  let lastPath = window.location.pathname;
  const unsubscribe = router.subscribe((state) => {
    const path = state.location.pathname;
    if (state.navigation.state === "idle" && path !== lastPath) {
      lastPath = path;
      trackPageView(path);                        // every route change
    }
  });
  return () => unsubscribe();
}, []);

  useEffect(() => {
    const savedTheme = Cookie.get("theme");
    if (!savedTheme) {
      Cookie.set("theme", "dark-theme", { 
        expires: 365,
        path: '/'
      });
      setTheme("dark-theme");
    }
  }, []);

  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('OneSignalSDKWorker.js')
        .then((reg) => console.log('Service worker registration succeeded:', reg))
        .catch(err => console.log('Service worker registration failed:', err));

      navigator.serviceWorker.register('OneSignalSDKUpdaterWorker.js')
        .then((reg) => console.log('Service worker registration succeeded:', reg))
        .catch(err => console.log('Service worker registration failed:', err));
    } else {
      console.log('Service workers are not supported.');
    }
  }, []);

  useOneSignal();

  return (
    <LogoProvider>
      <RouterProvider router={router} />
    </LogoProvider>
  );
}

export default App;
